import Vue from "vue";

export const store = Vue.observable({
  NITTO: "日東電工",
  NDCS: "日東電工ベースマテリアル",
  SHINKO: "日東シンコー",
  NITOMS: "ニトムズ",
  NITTO_CD : "N001",
  NDCS_CD : "N010",
  SHINKO_CD : "N003",
  NITOMS_CD : "N008"
});
